import { ICellEditorParams } from "@ag-grid-community/core";
import { Box, Input, useToast } from "@chakra-ui/react";
import React from "react";
import { IRegistryDataColumn } from "../../../models/RegistryDataColumn";

export const EditorText = React.forwardRef((props: ICellEditorParams, ref) => {
  const inputRef = React.useRef<any>();

  const toast = useToast();

  const [value, setValue] = React.useState(props.value);
  const [isValid, setIsValid] = React.useState(true);

  const colDef = props.colDef as any;
  const colMeta = colDef.meta as IRegistryDataColumn;

  const isRequired = colMeta.is_required;

  const inputHandler = (e) => {
    const inputValue = e.target.value;
    setValue(inputValue);
  };

  const isValidInput = React.useCallback((): boolean => {
    let isValidCheck = true;

    if (isRequired && !value) {
      isValidCheck = false;
    }

    if (colMeta.validation != null) {
      if (colMeta.validation == "date_ymd") {
        const reg = /^\d{4}-\d{2}-\d{2}$/;
        if (!(value.match(reg))) {
          isValidCheck = false
        }
      } else {
        const reg = new RegExp(colMeta.validation)
        if (value != null){
          if (!(value.match(reg))) {
            isValidCheck = false
          }
        }
      }
    }
    return isValidCheck;
  }, [isRequired, value]);

  React.useImperativeHandle(ref, () => {
    return {
      getValue: () => {
        return value;
      },

      isCancelAfterEnd: () => {
        const isValid = isValidInput();

        if (!isValid) {
          toast({
            title: "Required field",
            description: `Changes were reverted due to invalid input.`,
            status: "warning",
            duration: 4000,
            isClosable: true,
          });
        }

        return !isValid;
      },
    };
  });

  React.useEffect(() => {
    inputRef.current.focus();
    inputRef.current.select();
  }, []);

  React.useEffect(() => {
    const isValidUpdate = isValidInput();
    setIsValid(isValidUpdate);
  }, [value, isValidInput]);

  return (
    <Box h="full">
      <Input
        ref={inputRef}
        borderWidth="0"
        h="full"
        bg={isValid ? "inherit" : "bg.danger"}
        onChange={inputHandler}
        value={value}
        isRequired={isRequired}
      ></Input>
    </Box>
  );
});
